/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MaterialListComponent} from './material-list.component';
import {NgbCollapseModule, NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {PipesModule} from '../pipes/pipes.module';
import {WarningsModule} from '../warnings/warnings.module';
import {StatusDotModule} from '../status-dot/status-dot.module';
import {LoadingSpinnerModule} from '../loading/loading-spinner/loading-spinner.module';
import {MaterialListDetailComponent} from './material-list-detail/material-list-detail.component';
import {TableRowOverlayModule} from '../table-row-overlay/table-row-overlay.module';
import {ExcelUploadModule} from '../../spo/shared/excel-upload/excel-upload.module';
import {TooltipModule} from '../tooltip/tooltip.module';
import {GenericOverlayModule} from '../generic-overlay/generic-overlay.module';

@NgModule({
    declarations: [MaterialListComponent, MaterialListDetailComponent],
    imports: [
        CommonModule,
        NgbDropdownModule,
        PipesModule,
        WarningsModule,
        StatusDotModule,
        LoadingSpinnerModule,
        NgbCollapseModule,
        TableRowOverlayModule,
        ExcelUploadModule,
        TooltipModule,
        GenericOverlayModule
    ],
    exports: [MaterialListComponent]
})
export class MaterialListModule {
}
